import roleReportService from '@/services/roleReport.service';
import config from '@/config/prod.env';

const actions = {    
    async getRoleReportByWorkspaceIdAndRoleIds({ dispatch }, obj) {//
        return await roleReportService.getByWorkspaceIdAndRoleIds(obj.workspaceId, obj.roleIds);
    },

    async getByReportIdAndRoleIds({ dispatch }, obj) {
        return await roleReportService.getByReportIdAndRoleIds(obj.reportId, obj.roleIds);
    },
    
    async createRoleReportMultiple({ dispatch, commit }, obj) {
        let body = [];
        obj.roleIds.forEach(roleId => {
            body.push({
                reportId: obj.reportId, 
                roleId: roleId
            });
        });
        let res = await roleReportService.createMultiple(body);
        if(res.isOk) {
            dispatch("alert/success", "Cập nhật dữ liệu thành công", { root: true });
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    async deleteByReportIdAndRoleIds({ dispatch }, obj) {
        return await roleReportService.deleteByReportIdAndRoleIds(obj.reportId, obj.roleIds);
    },
};

export const roleReport = {
    namespaced: true,
    actions
};